<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>调整单信息</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>调整单号</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.innerNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>记账凭证号</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.reservedNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审批单号</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.auditPoofNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请人</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.applicantName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请状态</label>
                </div>
                <div class="form-value">
                    <span>{{applyStateMap[deprAdjustVoucher.applyState]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请描述</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.applyDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请时间</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.applyTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核人</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.auditorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核状态</label>
                </div>
                <div class="form-value">
                    <span>{{auditStateMap[deprAdjustVoucher.auditState]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核描述</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.auditDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核时间</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.auditTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>调整内容</label>
                </div>
                <div class="form-value">
                    <span v-if="deprAdjustVoucher.adjustType == 0">高级调整</span>
                    <span v-if="deprAdjustVoucher.adjustType == 1">原值调整</span>
                    <span v-if="deprAdjustVoucher.adjustType == 2">累计折旧调整</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>需要验收结算</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.settleNeeded ? '是' : '否'}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="deprAdjustVoucher.settleNeeded">
                <div class="form-label">
                    <label>供应商标识</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.sellerInnerCode || ''}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="deprAdjustVoucher.settleNeeded">
                <div class="form-label">
                    <label>调整金额含税</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.settleTaxOffset ? '不含税' : '含税'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>生凭公司</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.ledgerRealComName || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>生凭状态</label>
                </div>
                <div class="form-value">
                    <span class="font-red" v-if="deprAdjustVoucher.fiscalRevoked">已冲销</span>
                    <span v-else>{{ledgerStateMap[deprAdjustVoucher.ledgerState]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>生凭时间</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.ledgerTime || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备注</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.memo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="deprAdjustVoucher.pullBackNo != null && deprAdjustVoucher.pullBackNo != ''">
                <div class="form-label">
                    <label>已冲销</label>
                </div>
                <div class="form-value">
                    <span v-if="deprAdjustVoucher.pulledBack">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center" v-if="deprAdjustVoucher.pullBackNo != null && deprAdjustVoucher.pullBackNo != ''">
                <div class="form-label">
                    <label>冲销单号</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.pullBackNo}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="deprAdjustVoucher.pullBackNo != null && deprAdjustVoucher.pullBackNo != ''">
                <div class="form-label">
                    <label>冲销原因</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.rejectCause || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已作废</label>
                </div>
                <div class="form-value">
                    <span v-if="deprAdjustVoucher.invalid">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>作废原因</label>
                </div>
                <div class="form-value">
                    <span>{{deprAdjustVoucher.invalidCause || ''}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>资产信息</span>
        </div>
        <template v-if="itemList != null && itemList.length > 0">
            <div class="table-layout">
                <el-table ref="multipleTable" :data="itemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="devcInnerCode" min-width="160" label="资产编号" fixed show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row);">{{rows.row.devcInnerCode}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="retailerComFullName" label="部门全称" width="200" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="title" label="资产描述全称" width="200" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="name" label="名称" width="200" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="model" label="型号" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="tmpNo" min-width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="innerCode" min-width="120" label="资产定义编码" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="innerDevcBrandCode" min-width="150" label="资产品牌编码" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="innerDevcBrandName" min-width="150" label="资产品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="quantity" width="100" label="数量"></el-table-column>
                    <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                    <el-table-column align="center" min-width="100" label="调整方法">
                        <template slot-scope="rows">
                            <span>{{deprAdjustMethodMap[rows.row.method]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" min-width="100" label="业务单据类型">
                        <template slot-scope="rows">
                            <span>{{deprBizTypeMap[rows.row.bizVoucherType]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" min-width="100" label="业务单据号">
                        <template slot-scope="rows">
                            <span>{{rows.row.bizVoucherNo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" min-width="120" label="业务单据费用(元)">
                        <template slot-scope="rows">
                            <span>{{(rows.row.bizVoucherFee || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" min-width="100" label="折旧算法">
                        <template slot-scope="rows">
                            <span>{{deprMethodCodeMap[rows.row.deprMethodCode]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxPrice" align="right" width="120" label="调整前进项税额(元)">
                        <template slot-scope="rows">
                            <span>{{parseFloat(rows.row.taxPrice || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxPrice2" align="right" width="120" label="调整后进项税额(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.taxPrice2 != null">{{rows.row.taxPrice2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" align="right" width="120" label="调整前进项税率(%)">
                        <template slot-scope="rows">
                            <span>{{parseFloat(rows.row.taxRate || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate2" align="right" width="120" label="调整后进项税率(%)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.taxRate2 != null">{{rows.row.taxRate2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ntxPrice" align="right" width="120" label="调整前未税金额(元)">
                        <template slot-scope="rows">
                            <span>{{parseFloat(rows.row.ntxPrice || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ntxPrice2" align="right" width="120" label="调整后未税金额(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.ntxPrice2 != null">{{rows.row.ntxPrice2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="wtxPrice" align="right" width="120" label="调整前含税金额(元)">
                        <template slot-scope="rows">
                            <span>{{parseFloat(rows.row.wtxPrice || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="wtxPrice2" align="right" width="120" label="调整后含税金额(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.wtxPrice2 != null">{{rows.row.wtxPrice2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth" width="120" label="调整前资产原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgWorth != null">{{rows.row.orgWorth.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth2" width="120" label="调整后资产原值(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.orgWorth2 != null">{{rows.row.orgWorth2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="deprWorth" width="120" label="调整前近期折旧(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.deprWorth != null">{{rows.row.deprWorth.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="deprWorth2" width="120" label="调整后近期折旧(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.deprWorth2 != null">{{rows.row.deprWorth2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="durableLife" align="right" width="120" label="调整前使用年限(月)"></el-table-column>
                    <el-table-column prop="durableLife2" align="right" width="120" label="调整后使用年限(月)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.durableLife2 != null">{{rows.row.durableLife2}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="onsetDate" align="center" width="120" label="调整前起算日期"></el-table-column>
                    <el-table-column prop="onsetDate2" align="center" width="120" label="调整后起算日期">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.onsetDate2 != null">{{rows.row.onsetDate2}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rmnWorthRatio" align="right" width="120" label="调整前残值率(%)">
                        <template slot-scope="rows">
                            <span>{{parseFloat(rows.row.rmnWorthRatio || 0).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rmnWorthRatio2" align="right" width="120" label="调整后残值率(%)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.rmnWorthRatio2 != null">{{rows.row.rmnWorthRatio2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="aggtDeprWorth" width="160" label="调整前累计折旧/摊销(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.aggtDeprWorth != null">{{rows.row.aggtDeprWorth.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="aggtDeprWorth2" width="160" label="调整后累计折旧/摊销(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.aggtDeprWorthFlag && rows.row.aggtDeprWorth2!= null">{{rows.row.aggtDeprWorth2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="netWorth" width="120" label="调整前净值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorth != null">{{rows.row.netWorth.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="netWorth" width="120" label="调整后净值(元)">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.netWorth2 != null">{{rows.row.netWorth2.toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="deprMonth" width="100" label="最后折旧月份">
                        <template slot-scope="rows">
                            <span v-if="rows.row.deprMonth != null && rows.row.deprMonth > 0">{{rows.row.deprMonth}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" min-width="100" label="重算历史折旧">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.recalFlag">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" min-width="100" label="重算起始月份">
                        <template slot-scope="rows">
                            <span class="font-red">{{rows.row.recalMonth}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" min-width="100" label="重算完成">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.recalDone">已完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="recalTime" class="font-red" align="center" width="160" label="重算完成时间"></el-table-column>
                    <el-table-column prop="assetType" width="100" label="管理方式" align="center" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{rows.row.assetType == 0 ? '单品式管理' : '批量式管理'}}</span>
                        </template>
                    </el-table-column>
                    <template v-for="colNameX in durableColNames">
                        <el-table-column :label="colNameX" align="center" width="200" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <template v-if="scope.row.reservedNoJson != null" v-for="theJson in scope.row.reservedNoJson">
                                    <span v-if="theJson.text == colNameX">{{theJson.value}}</span>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </template>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { assetFiscalInfoDlg } from '../retailer/dialog'

    import shopDeviceApi from '../../api/shopDevc'
    import assetFiscalApi from '../../api/assetFiscal'
    //
    export default {
        name: 'swb-asset-depr-adjust-voucher-view',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '调整单详情',
        props: ['id'],
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                deprAdjustVoucher: {},
                itemList: [],
                //
                deprMethodCodeMap: {},
                applyStateMap: getEnumMap("applyState", "value2text"),
                auditStateMap: getEnumMap("auditState", "value2text"),
                deprAdjustMethodMap: getEnumMap("deprAdjustMethod", "value2text"),
                deprBizTypeMap: getEnumMap("deprBizType", "value2text"),
                ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
                colNames: [],
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.deprMethodCodeMap = getEnumMap("assetDeprMethod", "name2text");
            this.getAssetDeprAdjustVoucher();
        },
        methods: {
            // 查看资产信息
            viewAssetInfo: function (row) {
                let params = {
                    innerCode: row.devcInnerCode,
                    assetType: row.assetType
                };
                assetFiscalInfoDlg(params);
            },
            //
            getAssetDeprAdjustVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                assetFiscalApi.getAssetDeprAdjustVoucherInfo(postData, function (result) {
                    if(result.type == "info") {
                        let deprAdjustVoucher = result.data;
                        let itemList = Utils.merge([], deprAdjustVoucher.itemList);
                        let colNames = [];
                        itemList.forEach(function (item) {
                            let reservedNo = item.reservedNo;
                            if(!Utils.isNoB(reservedNo)) {
                                let reservedNoJson = JSON.decode(reservedNo);
                                let theNames = reservedNoJson.pluck('text');
                                colNames.add(Utils.compareArrays(theNames, colNames)['more']);
                                item.reservedNoJson = reservedNoJson;
                            }
                        });
                        self.colNames = colNames;
                        self.itemList = itemList;
                        self.deprAdjustVoucher = deprAdjustVoucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            toPrint(){
                let deprAdjustVoucher = this.deprAdjustVoucher;
                let url = '/voucher/print/jsp';
                let postData = {
                    bizType: 'biz.proof.zichan.tiaozheng',
                    voucherId: deprAdjustVoucher.id
                };
                let printUrl = Utils.makeUrl(getAppUrl(url), postData);
                Utils.setPageUrl(printUrl, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetDeprAdjustVoucherView.vue